export const AUTH_PAGE_PATHS = new Set([
  '/login',
  '/register',
  '/register-invite',
  '/reset-pass',
  '/retrieve-pass',
  '/mock-login'
])
export const REGISTER_PAGE_PATHS = new Set([
  '/register',
  '/register-invite',
  '/reset-pass',
  '/retrieve-pass'
])

interface AuthPageRedirectParams {
  currentPath: string
  hasToken: boolean
  isLoggedInResetPass: boolean
}

export function shouldRedirectAuthenticatedAuthPage({
  currentPath,
  hasToken,
  isLoggedInResetPass
}: AuthPageRedirectParams) {
  return (
    hasToken &&
    currentPath !== '/mock-login' &&
    AUTH_PAGE_PATHS.has(currentPath) &&
    !isLoggedInResetPass
  )
}

export function shouldClearAnonymousRegistrationState({
  currentPath,
  hasToken,
  isLoggedInResetPass
}: AuthPageRedirectParams) {
  return (
    !hasToken &&
    REGISTER_PAGE_PATHS.has(currentPath) &&
    !isLoggedInResetPass
  )
}
